import React, { useState } from "react";
import Modal from "react-modal";

import "../App.css";
import Slide from "./Slide.js";
import Off from "./Off.js";

Modal.setAppElement("#root");

const Producto = (props) => {
  const [modal_is_open, modal_is_open_update] = useState(false);

  let precio_inicial = "";
  let precio_final = props.product.price;

  if (props.product.off > 0) {
    precio_inicial = "$ " + props.product.price;
    precio_final =
      Math.round((props.product.price * (1 - props.product.off / 100)) / 10) *
      10;
  }

  if (props.product.agotado) {
    return (
      <div
        className="casilla"
        style={{ border: "1px rgb(221, 221, 221) solid" }}
      >
        <img
          className="foto"
          src={props.product.img1}
          alt=""
          style={{ opacity: "0.4" }}
        ></img>
        <div>
          <div className="titulo">
            <h1>{props.product.name}</h1>
            <div style={{ display: "flex", flexDirection: "row" }}>
              <h2>{precio_inicial.tag}</h2>
              <h2 style={{ marginRight: "5px" }}>{precio_inicial}</h2>
            </div>
          </div>
          <div className="teclado_agotado">
            <p className="agotado">AGOTADO</p>
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div className="casilla">
        <Modal
          isOpen={modal_is_open}
          onRequestClose={() => modal_is_open_update(false)}
          style={{
            content: {
              padding: "0",
              margin: "auto",
              top: "5px",
              right: "5px",
              bottom: "5px",
              left: "5px",
              borderRadius: "15px",
              maxWidth: "800px",
              maxHeight: "calc(100vh - 14vw)",
              zIndex: "5",
            },
            overlay: {
              backgroundColor: "rgba(0, 0, 0, 0.8)",
            },
          }}
        >
          <div className="casilla_modal">
            <div className="divvv1">
              <Slide
                img_1={props.product.img1}
                img_2={props.product.img2}
                img_3={props.product.img3}
              ></Slide>
              <div
                className="div_beneficio_producto"
                onClick={props.modal_beneficios}
              >
                <img
                  className="beneficio_producto"
                  src="/img/b_1.png"
                  alt=""
                  style={{ opacity: props.product.beneficios[0] }}
                ></img>
                <img
                  className="beneficio_producto"
                  src="/img/b_2.png"
                  alt=""
                  style={{ opacity: props.product.beneficios[1] }}
                ></img>
                <img
                  className="beneficio_producto"
                  src="/img/b_3.png"
                  alt=""
                  style={{ opacity: props.product.beneficios[2] }}
                ></img>
                <img
                  className="beneficio_producto"
                  src="/img/b_4.png"
                  alt=""
                  style={{ opacity: props.product.beneficios[3] }}
                ></img>
                <img
                  className="beneficio_producto"
                  src="/img/b_5.png"
                  alt=""
                  style={{ opacity: props.product.beneficios[4] }}
                ></img>
                <img
                  className="beneficio_producto"
                  src="/img/b_6.png"
                  alt=""
                  style={{ opacity: props.product.beneficios[5] }}
                ></img>
                <img
                  className="beneficio_producto"
                  src="/img/b_7.png"
                  alt=""
                  style={{ opacity: props.product.beneficios[6] }}
                ></img>
                <img
                  className="beneficio_producto"
                  src="/img/b_8.png"
                  alt=""
                  style={{ opacity: props.product.beneficios[7] }}
                ></img>
              </div>
            </div>

            <div className="divvv2">
              <h4
                style={{
                  fontSize: "20px",
                  margin: "35px 20px 20px 20px",
                  textAlign: "left",
                }}
              >
                {props.product.name} · {props.product.tag}
              </h4>
              <div style={{ display: "flex", flexDirection: "row" }}>
                <p
                  style={{
                    fontSize: "15px",
                    marginLeft: "20px",
                    textAlign: "justify",
                    opacity: "0.9",
                  }}
                >
                  ${" "}
                  {precio_final
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ".")}
                </p>
                <p
                  style={{
                    fontSize: "15px",
                    marginLeft: "20px",
                    textAlign: "justify",
                    opacity: "0.9",
                    textDecoration: "line-through",
                  }}
                >
                  {precio_inicial}
                </p>
              </div>
              <p
                style={{
                  fontSize: "15px",
                  margin: "20px",
                  textAlign: "justify",
                  opacity: "0.9",
                }}
              >
                {props.product.desc1}
              </p>
              <p
                style={{
                  fontSize: "15px",
                  margin: "20px",
                  textAlign: "justify",
                  opacity: "0.9",
                }}
              >
                {props.product.desc2}
              </p>
              <img className="tam_class" src={props.product.tam} alt=""></img>
              <div
                className="teclado"
                style={{
                  opacity: props.product.n > 0 ? "1" : "0.6",
                  marginBottom: "15px",
                }}
              >
                <div
                  className="add"
                  onClick={() =>
                    props.product.n > 0 ? props.remove(props.product.name) : ""
                  }
                >
                  <img src="./img/-_2.jpg" alt=""></img>
                </div>

                <h3 className="ok">{props.product.n}</h3>

                <div
                  className="add"
                  onClick={() => props.add(props.product.name)}
                >
                  <img src="./img/+_2.png" alt=""></img>
                </div>
              </div>
            </div>
          </div>
          <img
            className="close_button"
            src="/img/close.png"
            alt=""
            onClick={() => modal_is_open_update(false)}
          ></img>
        </Modal>

        <Off off={props.product.off} />

        <img
          className="foto"
          src={props.product.img1}
          alt=""
          onClick={() => modal_is_open_update(true)}
        ></img>
        <div>
          <div className="titulo" onClick={() => modal_is_open_update(true)}>
            <h1>{props.product.name} </h1>
            <div style={{ display: "flex", flexDirection: "row" }}>
              <h2>
                ${precio_final.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}
              </h2>
              <h2
                style={{
                  display:
                    props.product.name.charAt(0) === "(" ? "block" : "none",
                }}
              >
                + IVA
              </h2>
              <h2
                style={{
                  color: "rgb(182, 182, 182)",
                  textDecoration: "line-through",
                }}
              >
                {precio_inicial
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ".")}
              </h2>
            </div>
          </div>
          <div
            className="teclado"
            style={{
              opacity: props.product.n > 0 ? "1" : "0.5",
            }}
          >
            <div
              className="add"
              onClick={() =>
                props.product.n > 0 ? props.remove(props.product.name) : ""
              }
            >
              <img src="./img/-_2.jpg" alt=""></img>
            </div>

            <h3 className="ok">{props.product.n}</h3>

            <div
              className="add"
              onClick={() =>
                props.product.n < 100 ? props.add(props.product.name) : ""
              }
            >
              <img src="./img/+_2.png" alt=""></img>
            </div>
          </div>
        </div>
      </div>
    );
  }
};

export default Producto;
